export enum ModuleEnum {
    IntroToDataCollection = 1,
    GeneralInformationPaOne = 2,
    Breastfeeding = 3,
    ComplementaryFeeding = 4,
    MicronutrientPowders = 5,
    VitaminASupplementation = 6,
    Deworming = 7,
    PreventionOfOverweight = 8,
    GeneralInformationPaTwo = 9,
    NutritionOfSchoolAgeChildren = 10,
    NutritionOfAdolescents = 11,
    MaternalNutrition = 12,
    UniversalSaltIodization = 13,
    FoodSystems = 14,
    CareForChildrenWithSAM = 15,
    EmergencyPreparednessAndResponse = 16,
    KnowledgePartnerships = 17,
    SamForecast = 18,
    MnpForecast = 19,
    VitaminAForecast = 20
}

export enum ModuleType {
    GeneralInformation = 1,
    Coverage = 2,
    Forecast = 3
}

export enum ModuleSubmissionStatusEnum {
    InProgress = 1,
    Completed = 2
}

export enum QuestionType {
    Textbox = 1,
    Numeric = 2,
    Datepicker = 3,
    Dropdown = 4,
    Radiobutton = 5,
    Checkbox = 6,
    AdminLevel = 7,
    Other = 8
}

export enum QuestionStatus {
    Draft = "Draft",
    SubmittedForReview = "Submitted for Review",
    Approve = "Approved",
    Reject = "Reject",
    AssignToCreator = "Assign to Creator",
    Modified = "Modified"
}

export enum AdminQuestionStatus {
    None = 0,
    Approve = 1,
    Reject = 2,
    AssignToCreator = 3,
}


// WEBPACK FOOTER //
// ./src/constants/Enum/ModuleEnum.tsx